import { ApiWidgetMetric } from "@/types/reporting/reporting.types.ts";
import {
  Button,
  DropdownMenu,
  DropdownMenuItem,
  FontAwesomeIcon,
  SelectItem,
} from "@skailer-com/uikit";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export interface RetentionMetricSelectorProps {
  value: ApiWidgetMetric;
  onChange: (metric: ApiWidgetMetric) => void;
}

export function RetentionMetricSelector({ value, onChange }: RetentionMetricSelectorProps) {
  const { t } = useTranslation();

  const options: SelectItem[] = useMemo(
    () => [
      {
        id: ApiWidgetMetric.turnover_rate,
        title: t("reporting:metric_turnover"),
        icon: "fa-light fa-arrow-right-arrow-left",
      },
      {
        id: ApiWidgetMetric.attrition_rate,
        title: t("reporting:metric_attrition"),
        icon: "fa-light fa-arrow-down-right",
      },
      {
        id: ApiWidgetMetric.retention_rate,
        title: t("reporting:metric_retention"),
        icon: "fa-light fa-heart",
      },
      {
        id: ApiWidgetMetric.average_tenure,
        title: t("reporting:metric_tenure"),
        icon: "fa-light fa-hourglass-half",
      },
      {
        id: ApiWidgetMetric.average_age,
        title: t("reporting:metric_age"),
        icon: "fa-light fa-cake-candles",
      },
    ],
    [t]
  );

  const selectedOption = useMemo(
    () => options.find((x) => x.id === value) || options[0],
    [value, options]
  );

  return (
    <DropdownMenu
      trigger={
        <Button
          variant={"secondary"}
          rightIcon={<FontAwesomeIcon icon={"fa-light fa-chevron-down shrink-0"} />}
        >
          {selectedOption?.title}
        </Button>
      }
    >
      {options.map((option: SelectItem) => (
        <DropdownMenuItem
          key={`retention-metric-${option.id}`}
          title={option.title}
          leftIcon={option.icon ? <FontAwesomeIcon icon={option.icon} /> : undefined}
          isSelected={selectedOption?.id === option.id}
          onClick={() => {
            onChange(option.id as ApiWidgetMetric);
          }}
        />
      ))}
    </DropdownMenu>
  );
}
